/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2023/9/8 10:28
 * @des  设备ID工具
 */
import {uuid} from './uuid'
import {
  getItem,
  setItem
} from '../store/storage'

const STORAGE_TAG_DEVICE_ID = 'STORAGE_TAG_DEVICE_ID'
const DEVICE_ID_PRE = 'web_'

export function getDeviceId () {
  let res = getItem(STORAGE_TAG_DEVICE_ID)
  if (res) {
    return DEVICE_ID_PRE + res
  } else {
    let deviceId = uuid()
    setItem(STORAGE_TAG_DEVICE_ID, deviceId)
    return DEVICE_ID_PRE + deviceId
  }
}



// WEBPACK FOOTER //
// ./src/base/util/deviceutil.js